import { Card } from '@/components/ui/card';
import { CollapsibleContainer } from '@/components/ui/collapsible-container';
import { CollapsibleText } from '@/components/ui/collapsible-text';
import { RichTextViewer } from '@/features/rich-text/components/rich-text-viewer';
import { useLocale } from '@/lib/hooks/use-locale';
import type { RouterOutput } from '@/server/types/infer-trpc-types';

interface Props {
    data: RouterOutput['platoUser']['getDetailProduct']['getProductDetail'];
}

export const InventoryDetailsDescription = ({ data: data }: Props) => {
    const { t } = useLocale();

    // Use the backend-provided combined and sanitized description
    if (!data.description) {
        return null;
    }

    return (
        <CollapsibleContainer defaultOpen title={t('description', { ns: 'product-details' })}>
            <Card>
                <CollapsibleText canOpen>
                    <RichTextViewer content={data.description} />
                </CollapsibleText>
            </Card>
        </CollapsibleContainer>
    );
};
